import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { WorkspacesPage } from '@/features/admin/workspaces/workspace-pages';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Entrée « jupyter » de la navigation : les espaces de travail de ce type (revue C13). */
export const Route = createFileRoute('/$tenant/jupyter')({ component: JupyterRoute });

function JupyterRoute() {
  const { tenant } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell tenantId={tenant} activeItem="jupyter" crumbs={[{ label: t('nav.items.jupyter') }]}>
      <WorkspacesPage tenantId={tenant} kind="jupyter" />
    </ConsoleShell>
  );
}
